import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import autoBind from 'react-autobind';
import { renderInput } from 'src/components/misc/redux-form-helpers';
import { isBlank } from 'src/components/misc/validations';

class EmailToJourneyForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {};
    }

    render() {
        const { handleSubmit, t, offerUrl } = this.props;
        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <Field
                            name="emailInput"
                            placeholder="Email"
                            label="Email *"
                            t={t}
                            disabled={offerUrl != null}
                            required
                            component={renderInput}
                            rows={3}
                            maxRows={5}
                            multiline
                        />
                    </div>
                </div>
                <button type="submit" className="btn btn-xs">
                    Anfrage senden
                </button>
            </form>
        );
    }
}

const validate = (values, props) => {
    const errors = {};

    if (isBlank(values.emailInput)) errors.name = 'Bitte Anfrage angeben';

    return errors;
};

export default reduxForm({
    form: 'emailToJourneyForm',
    validate,
})(EmailToJourneyForm);
